// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoCodeLibraryOutlinedSvg from "@fishx/icons-svg/es/asn/PtoCodeLibraryOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoCodeLibraryOutlined = function PtoCodeLibraryOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoCodeLibraryOutlinedSvg
  }));
};

PtoCodeLibraryOutlined.displayName = 'PtoCodeLibraryOutlined';
export default React.forwardRef(PtoCodeLibraryOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoCodeLibraryOutlined.js
// module id = 3891
// module chunks = 0